module.exports = __webpack_public_path__ + "img/admin-login-background.1d036e63.png";